import createReducer from './createReducer'
import * as types from '../common/types'
import _ from 'lodash'

const initialState = {
  location: {},
  subscriptions: {},
  user: {},
  home: {},
  homeGroup: {},
  filters: {},
  sortTypes: {
    logs: '-timeLogged'
  },
  permissionsLoading: true
}

export const global = createReducer(initialState, {
  [types.SET_GLOBAL_USER](state, { user }) {
    const newState = { ...state }
    newState.user = user
    return newState
  },
  [types.SET_HOME_GROUP](state, { homeGroup = {} }) {
    const newState = { ...state }
    newState.homeGroup = homeGroup
    return newState
  },
  [types.SET_HOME_DETAILS](state, { homeDetails = {} }) {
    const newState = { ...state }
    if (homeDetails && homeDetails.key) {
      return {
        ...state,
        home: {
          ...state.home,
          [homeDetails.key]: homeDetails.value
        }
      }
    }
    newState.home = homeDetails || {}
    return newState
  },
  [types.SET_WINDOW_LOCATION_HISTORY](state, { location }) {
    return {
      ...state,
      location: {
        prev: state.location.current,
        current: location
      }
    }
  },
  [types.SET_CB_SUBSCRIPTION_DETAILS](state, { subscriptions }) {
    return {
      ...state,
      subscriptions
    }
  },
  [types.SET_CB_CUSTOMER_DETAILS](state, { customer }) {
    return {
      ...state,
      customer
    }
  },
  [types.SET_SORT_TYPE](state, { key, sortType }) {
    return {
      ...state,
      sortTypes: {
        ...state.sortTypes,
        [key]: sortType
      }
    }
  },
  [types.TOGGLE_ACTIVE_FILTER](state, { filterId, key, value }) {
    if (!state.filters[filterId] || !state.filters[filterId][key]) {
      return {
        ...state,
        filters: {
          ...state.filters,
          [filterId]: {
            ...state.filters[filterId],
            [key]: value instanceof Array ? value : [value]
          }
        }
      }
    }
    const filter = _.clone(state.filters[filterId][key])

    let newValue
    if (value instanceof Array) {
      newValue = value
    } else {
      newValue = filter.includes(value)
        ? _.pull(filter, value)
        : [...filter, value]
    }

    return {
      ...state,
      filters: {
        ...state.filters,
        [filterId]: {
          ...state.filters[filterId],
          [key]: newValue
        }
      }
    }
  },
  [types.RESET_FILTER](state, { filterId }) {
    return {
      ...state,
      filters: {
        ...state.filters,
        [filterId]: {}
      }
    }
  },
  [types.RESET_SELECTED_FILTER](state, { filterId, filterKey }) {
    if (!state.filters[filterId]) {
      return { ...state }
    }
    return {
      ...state,
      filters: {
        ...state.filters,
        [filterId]: { ...state.filters[filterId], [filterKey]: [] }
      }
    }
  },
  [types.TOGGLE_LOADING](state) {
    return {
      ...state,
      loading: !state.loading
    }
  },
  [types.FLAGSMITH](state, { name, data }) {
    return {
      ...state,
      flagsmith: {
        ...state.flagsmith,
        [name]: data
      }
    }
  },
  [types.SET_ABILITY](state, { ability = {} }) {
    return {
      ...state,
      ability
    }
  },
  [types.SET_PERMISSION_TEMPLATES](state, { permissionTemplates }) {
    return {
      ...state,
      permissionTemplates
    }
  },
  [types.SET_PERMISSIONS_LOADING](state, { loading }) {
    return {
      ...state,
      permissionsLoading: loading
    }
  }
})
